var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlineGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90327 0.869125C10.0681 0.361886 10.7857 0.361887 10.9505 0.869124L12.5032 5.64791C12.7033 6.26363 13.2771 6.68051 13.9245 6.68051H18.9492C19.4825 6.68051 19.7043 7.36299 19.2728 7.67648L15.2077 10.6299C14.684 11.0105 14.4648 11.685 14.6649 12.3007L16.2176 17.0795C16.3824 17.5867 15.8018 18.0085 15.3703 17.695L11.3053 14.7416C10.7815 14.3611 10.0723 14.3611 9.54851 14.7416L5.48343 17.695C5.05195 18.0085 4.47139 17.5867 4.6362 17.0795L6.18893 12.3007C6.38899 11.685 6.16982 11.0105 5.64606 10.6299L1.58098 7.67648C1.1495 7.36299 1.37125 6.68051 1.90459 6.68051H6.92931C7.57671 6.68051 8.15049 6.26363 8.35055 5.64791L9.90327 0.869125Z",
    stroke: "#98A2B3",
    strokeWidth: 0.94382
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlineGray);
export default __webpack_public_path__ + "static/media/star-outline-gray.69f5f7658a56a1db3bebde72319c8e89.svg";
export { ForwardRef as ReactComponent };